<div class="document-list-cards-section">

  <mat-accordion>
      @for(document of documents; track document.documentId) 
      {
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title class="document-name">{{ document.name }}</mat-panel-title>
          </mat-expansion-panel-header>
          <div class="document-content">
            <div class="status">
              <span class="status-header">Estado</span>
                <signature-request-document-status-badge
                  [status]="document.status">
                </signature-request-document-status-badge>
            </div>
            <hr/>
            <h5>Firmantes</h5>
            @for (signatory of document.signatories; track $index) {
              <div  class="signatory-section">
                <div class="signatory-info">
                  <span>{{ signatory.name }}</span>
                  <span class="signatory-identification">{{ signatory.identification | rut }}</span>
                  <signature-signatory-status-badge
                    [status]="signatory.status">
                  </signature-signatory-status-badge>
                </div>
              </div>
            }
          </div>
        </mat-expansion-panel>
      }
  </mat-accordion>
</div>